var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c(
        "el-scrollbar",
        {
          class: { active: _vm.collapse },
          staticStyle: { height: "100%", width: "190px" }
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "sidebar-el-menu",
              attrs: {
                collapse: _vm.collapse,
                "background-color": "#283443",
                "text-color": "#fff",
                "active-text-color": "#20a0ff",
                router: ""
              }
            },
            _vm._l(_vm.items, function(item, n) {
              return _c("nav-bar-item", {
                key: n,
                attrs: { item: item, navIndex: String(n) }
              })
            })
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2760279e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2760279e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar.vue
// module id = null
// module chunks = 